export { AggregatesState } from './aggregates.reducer';

export { AggregatesEffect } from './aggregates.effects';

export { AggregatesFacade } from './aggregates.facade';
